import { isBrowserNetworkError } from './is-browser-network-error';

const MODULE_FETCH_ERROR_PREFIX = 'Failed to fetch dynamically imported module: ';
const MODULE_SCRIPT_LOAD_ERROR_MESSAGE = 'Importing a module script failed.';
const FIREFOX_MODULE_FETCH_ERROR_MESSAGE = 'error loading dynamically imported module';
const FIREFOX_MODULE_FETCH_ERROR_PREFIX = `${FIREFOX_MODULE_FETCH_ERROR_MESSAGE}: `;

export const getModuleLoadErrorAttributes = (
	error: Error,
): { moduleLoadFailure?: true; errorCode?: number } => {
	if (error.name === 'TypeError' && error.message === MODULE_SCRIPT_LOAD_ERROR_MESSAGE) {
		return { moduleLoadFailure: true };
	}

	const isChromeModuleFetchError =
		error.message.startsWith(MODULE_FETCH_ERROR_PREFIX) && isBrowserNetworkError(error);
	const isFirefoxModuleFetchError =
		error.name === 'TypeError' &&
		(error.message === FIREFOX_MODULE_FETCH_ERROR_MESSAGE ||
			error.message.startsWith(FIREFOX_MODULE_FETCH_ERROR_PREFIX));
	if (!isChromeModuleFetchError && !isFirefoxModuleFetchError) {
		return {};
	}

	const attributes = { moduleLoadFailure: true as const };

	try {
		const url = isChromeModuleFetchError
			? error.message.slice(MODULE_FETCH_ERROR_PREFIX.length)
			: error.message.slice(FIREFOX_MODULE_FETCH_ERROR_PREFIX.length);
		if (!url) {
			return attributes;
		}
		const entry = performance.getEntriesByName(url, 'resource').at(-1);
		const status = entry && 'responseStatus' in entry ? entry.responseStatus : undefined;
		if (typeof status === 'number' && Number.isInteger(status) && status >= 100 && status <= 599) {
			return { ...attributes, errorCode: status };
		}
	} catch {
		// Resource timing is best effort and must not interrupt error reporting.
	}

	return attributes;
};
